module.exports = __webpack_public_path__ + "dc9a85070313070212ac0b1c50e90b88.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-28.png
// module id = 1745
// module chunks = 0